export default __webpack_public_path__ + "static/media/telegram-logo.e9722f26.png";